import { makeStyles } from '@material-ui/core/styles';

export const useBackButtonStyles = makeStyles(() => ({
  link: {
    width: '100%',
    backgroundColor: '#F1F1F1',
    color: 'black',
    padding: 10,
  },
  type: {
    fontSize: 14,
    fontWeight: 600,
  },
}));
